import Fade, { FadeProps } from '@mui/material/Fade'
import Box from '@mui/system/Box'

interface TransitionFadeProps extends Omit<FadeProps, 'in' | 'children'> {
   visible: boolean
   children: React.ReactNode
}

export default function TransitionFade({ visible, children, ...props }: TransitionFadeProps) {

   return (
      <Fade in={visible} {...props}>
         <Box style={{ margin: 0, padding: 0 }}>{!!visible && children}</Box>
      </Fade>
   )
}
